import './SideBookMarks.scss';

import { ReactElement } from 'react';
import SlidingPanel from 'react-sliding-side-panel';
import LineAwesome from '../LineAwesome/LineAwesome';
import { BookmarkCollection } from '../../containers/BookmarkCollection/BookmarkCollection';
import { useWindowSize } from '../../utils/hooks/useWindowSize';

interface SideBookMarksProps {
  openBookmarks: boolean;
  toggleBookmarks: () => void;
}

// Panel width as a percentage of the viewport: full-screen on mobile, narrower
// on larger screens.
const panelSizeForWidth = (width: number): number => {
  if (width > 1399) {
    return 30;
  }
  if (width < 769) {
    return 100;
  }
  return 60;
};

export const SideBookMarks = ({
  openBookmarks,
  toggleBookmarks
}: SideBookMarksProps): ReactElement => {
  const [width] = useWindowSize();

  return (
    <SlidingPanel
      type='right'
      isOpen={openBookmarks}
      size={panelSizeForWidth(width)}
      backdropClicked={toggleBookmarks}>
      <div className='bookmark-overlay'>
        <div className='bookmark-overlay__close'>
          <LineAwesome icon='times-circle' onClick={toggleBookmarks} />
        </div>
        <div className='bookmark-overlay__content'>
          <BookmarkCollection editMode={false} onNavigate={toggleBookmarks} />
        </div>
      </div>
    </SlidingPanel>
  );
};
